import {http} from "@/utils/http";
import {cleanParams} from "@/utils/cleanParams";

export const personalService = {
    getChatMessages(chat_id: number, filter: unknown) {
        return http.get(`/chats/${chat_id}/messages`, {
            params: cleanParams(filter)
        })
    }
}